export default "__VITE_ASSET__CB_Mp7SZ__"